import {isFeatureEnabled} from '@github-ui/feature-flags'
import {getPersisterStorageKey} from '@github-ui/react-query-persister/storage-key'

export type IssueViewerFeed = 'comments' | 'activity'
export type IssueViewerStorageCoordinates = {owner: string; repo: string; number: number; feed: IssueViewerFeed}

export const ISSUE_VIEWER_PERSISTER_PREFIX = 'server-persisted-query'

export function getIssueViewerFeed(): IssueViewerFeed {
  return isFeatureEnabled('issue_viewer_activity_tab') ? 'comments' : 'activity'
}

export function issueViewerFeedFromTimelineItemTypes(
  timelineItemTypes: readonly string[] | null | undefined,
): IssueViewerFeed {
  return timelineItemTypes?.length === 1 && timelineItemTypes[0] === 'ISSUE_COMMENT' ? 'comments' : 'activity'
}

export function timelineItemTypesForIssueViewerFeed(feed: IssueViewerFeed): readonly ['ISSUE_COMMENT'] | undefined {
  return feed === 'comments' ? ['ISSUE_COMMENT'] : undefined
}

export function getIssueViewerStorageQueryKey({
  owner,
  repo,
  number,
  feed,
}: IssueViewerStorageCoordinates): readonly unknown[] {
  // Activity keeps the pre-split key so persisted entries and the service worker lookup stay valid.
  return feed === 'comments'
    ? ['issue-viewer', 'primary-view', {number, owner, repo, feed}]
    : ['issue-viewer', 'primary-view', {number, owner, repo}]
}

export function getIssueViewerPersisterStorageKey(coordinates: IssueViewerStorageCoordinates): string {
  return getPersisterStorageKey({
    prefix: ISSUE_VIEWER_PERSISTER_PREFIX,
    queryKey: getIssueViewerStorageQueryKey(coordinates),
  })
}
